export default "__VITE_ASSET__5b0b8ac6__"